import SelectNewsletters from '@piconetworks/select-newsletters'
import withInjection from '@piconetworks/with-injection'

import { GO_TO_MENU_ROUTE_AND_OPEN } from '@piconetworks/menu-middleware'
import Account from 'common/modules/account'
import Internal from 'common/modules/internal'
import Loader from 'common/modules/loader'
import Wizard from 'common/modules/wizard'

import WizardRedux from 'common/pkgs/WizardRedux'

const mapStateToProps = (state, props) => ({
    ...props,
    isReadyToMount: !state?.loader?.isFetching && Loader.selectors.currentPlanTierId(state),
    getScopedLoader: (scope) => Loader.selectors.scopedLoader(state, scope),
    loader: Loader.selectors.loader(state),
    thisWizard: Wizard.selectors.thisWizard({ state, router: props.router }),
    userSyncNewsletters: Loader.selectors.userSyncNewsletters(state),
    wizard: state.wizard,
    currentPlanTierId: Loader.selectors.currentPlanTierId(state),
    publisherId: Loader.selectors.publisherId(state),
    newsletterFilter: props.newsletterFilter || 'plan_unlock',
    updateLoaderUserNewsletters: (args) => Internal.creators.sendMessage({
        payload: {
            target: 'pico_arbiter',
            ...Loader.creators.updateLoaderUserNewsletters(args),
        },
    }),
    WizardRedux,
})

const mapDispatchToProps = (dispatch) => ({
    onNewsletterUpdate: () => {
        dispatch({
            type: GO_TO_MENU_ROUTE_AND_OPEN,
            payload: {
                menuRoute: '/notification',
                text: 'Your newsletter preferences have been successfully updated.',
                backRoute: '/manageNewsletters',
            },
        })
    },
    newsletterSubscribe: (payload) => Internal.helpers.invalidateLoader({
        payload,
        action: Account.creators.newsletterSubscribe,
        dispatch,
    }),
})

const InjectedSelectNewsletters = withInjection(SelectNewsletters, {
    mapStateToProps,
    mapDispatchToProps,
})

export default InjectedSelectNewsletters
